import React from 'react';
import { graphql } from 'gatsby';

import marked from 'marked';
import Layout from '../components/Layout';
import Header from '../sections/Header';
import { AboutTCMarkDown } from '../sections/AboutTC';
import { ProgrammePostEnglandSection } from '../sections/CardsSections';
import { GeneralCardsSection } from '../sections/Cards';

import placeholderData from '../utils/placeholderData';
import ActionCards, { Banners } from '../sections/ActionCards';

export const TempoTimeCreditsEnglandTemplate = ({
  outcomesTitle,
  outcomesContent,
  programmesPostsTitle,
  preview,
}) => {
  return (
    <>
      <Header page="timeCreditsEngland" title="Tempo Time Credits in England" />
      <AboutTCMarkDown
        darkBG
        title={outcomesTitle}
        content={outcomesContent && marked(outcomesContent)}
      />
      <Banners type="TCEngland" />
      {preview ? (
        <GeneralCardsSection
          data={placeholderData}
          type="programmes"
          title={programmesPostsTitle}
        />
      ) : (
        <ProgrammePostEnglandSection title={programmesPostsTitle} />
      )}
      <ActionCards language="english" />
    </>
  );
};

const TempoTimeCreditsEnglandPage = ({
  data: {
    markdownRemark: { frontmatter },
  },
}) => {
  return (
    <Layout>
      <TempoTimeCreditsEnglandTemplate {...frontmatter} />
    </Layout>
  );
};
export const TempoTimeCreditsEnglandQuery = graphql`
  query TempoTimeCreditsEnglandQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        outcomesTitle
        outcomesContent
        programmesPostsTitle
      }
    }
  }
`;

export default TempoTimeCreditsEnglandPage;
